import {Inject, Injectable, Renderer2, RendererFactory2, DOCUMENT} from '@angular/core';
import {Title} from '@angular/platform-browser';




@Injectable({
  providedIn: 'root'
})
export class HtmlService {

  private renderer: Renderer2;

  constructor(
    private title: Title,
    @Inject(DOCUMENT) private document: Document,
    private rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  setTitle = (value: any) => {
   this.title.setTitle(`${value} - Bidone ERP`);
  }

  getTitle = () => {
    return this.title.getTitle();
  }

  addClass = (element: any, name: any) => {
    this.renderer.addClass(element, name);
  }

  removeClass = (element: any, name: any) => {
    this.renderer.removeClass(element, name);
  }

  addBodyClass = (name: any = 'jumbo-page') => {
    this.renderer.addClass(this.document.body, name);
  }

  removeBodyClass = (name: any = 'jumbo-page') => {
    this.renderer.removeClass(this.document.body, name);
  }

}
